import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { colors } from "../../utility/types/constant";

const CountDownTimer = ({ seconds, onFinish }: any) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    // exit early when reached 0;
    if (!timeLeft) return onFinish();

    // save intervalId, in order to clear intervalId upon component re-render.
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear intervalId on re-renders
    return () => clearInterval(intervalId);
    // adding time left as dependency to re-run the effect
    // when updating
  }, [timeLeft, onFinish]);

  return (
    <Typography
      component="span"
      sx={{ color: colors.successGreen, fontSize: 20 }}
    >
      {timeLeft}
    </Typography>
  );
};

export default CountDownTimer;
